const constant = {
  SEX_MAN: 0,
  SEX_WOMAN: 1,
  MARRIAGE_YES: 1,
  MARRIAGE_NO: 0,
  ACTIVE_NO: 0,
  ACTIVE_YES: 1
}
export default constant



// WEBPACK FOOTER //
// ./src/constant.js